/**
 * Chaves estáveis das esteiras de sistema — espelho de `src/common/esteiras.ts` do backend.
 * Sempre comparar esteiras pela `chave` (o `id` seedado, ex: `est-entrega`, é detalhe da migration).
 */
export const ESTEIRA = {
  AGUARDANDO: 'AGUARDANDO',
  AGUARDANDO_PROXIMA_ETAPA: 'AGUARDANDO_PROXIMA_ETAPA',
  ORCAMENTO: 'ORCAMENTO',
  AGUARDANDO_ENTREGA: 'AGUARDANDO_ENTREGA',
  ENTREGA: 'ENTREGA',
} as const;

export type EsteiraChave = (typeof ESTEIRA)[keyof typeof ESTEIRA];
